import {QueryKey} from '@tanstack/query-core';
import {UseQueryOptions, UseQueryResult} from '@tanstack/react-query';
import {useBaseQuery} from './useBaseQuery';

export function useLowFrequencyRefreshQuery<
    TQueryFnData = unknown,
    TError = unknown,
    TData = TQueryFnData,
    TQueryKey extends QueryKey = QueryKey,
>(options: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>): UseQueryResult<TData, TError> {
    const staleTime = 30 * (60 * 1000); // 30 minutes

    return useBaseQuery<TQueryFnData, TError, TData, TQueryKey>({
        ...options,
        staleTime,
    });
}
